<div e2e-question-code="poBoxModel" e2e-render-type="radio-button">
  <mat-radio-group
    class="mb-6 flex w-full flex-col gap-2 md:flex-row"
    [(ngModel)]="poBoxModel"
    [disabled]="isDisabled()"
    [ngModelOptions]="{ standalone: true }"
    aria-label="Address type"
    (ngModelChange)="$event ? (useServiceAddress = false) : null"
  >
    <csl-mat-radio
      [value]="false"
      class="w-full"
      [isHidden]="true"
      [attr.e2e-data-value]="false"
      [attr.e2e-data-selected]="poBoxModel === false"
    >
      <csl-radio-tab
        [isDisabled]="isDisabled()"
        [label]="'Street Address'"
        [selected]="poBoxModel === false"
        class="w-full"
      ></csl-radio-tab>
    </csl-mat-radio>
    <csl-mat-radio
      [value]="true"
      class="w-full"
      [isHidden]="true"
      [attr.e2e-data-value]="true"
      [attr.e2e-data-selected]="poBoxModel === true"
    >
      <csl-radio-tab
        [isDisabled]="isDisabled()"
        [label]="'PO Box Address'"
        [selected]="poBoxModel === true"
        class="w-full"
      ></csl-radio-tab>
    </csl-mat-radio>
  </mat-radio-group>
</div>
<div
  class="mt-6 flex items-center gap-3"
  [class.hidden]="poBoxModel"
  e2e-question-code="isSameAddress"
  e2e-render-type="boolean-checkbox"
>
  <input
    class="checkbox"
    type="checkbox"
    id="useServiceAddress"
    [disabled]="isDisabled()"
    [ngModel]="useServiceAddress"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="onUseServiceAddressChanged($event)"
  />

  <label for="useServiceAddress" class="text-gray-750 text-base">Use service address</label>
</div>

<csl-address-form
  class="self-stretch"
  [isDisabled]="isDisabled()"
  [emitInitialValue]="true"
  [withPoBox]="poBoxModel"
  [address]="initialAddress"
  (addressChange)="addressChanged($event)"
  (cityChanged)="cityChanged.emit()"
  (zipChanged)="zipChanged.emit()"
  (stateChanged)="stateChanged.emit()"
  (streetError)="streetError.emit($event)"
  (cityError)="cityError.emit($event)"
  (zipError)="zipError.emit($event)"
  (stateError)="stateError.emit($event)"
/>
